import { IFestivalMenuItem } from '../services/menu'

export type TPermissionTypes =
  | 'STAGES'
  | 'INVITES'
  | 'ARTISTS'
  | 'NOTIFICATIONS'
  | 'ORDERS_EXPORT'
  | 'INFO'
  | 'CLIENTS_EXPORT'
  | 'TICKETS'
  | 'ORDERS'
  | 'TICKETS_ADD_ONS'
  | 'ORDERS_MONTHLY_PAYMENTS'
  | 'REFERRALS'
  | 'VOUCHERS'
  | 'PARTNERS_CATEGORIES'
  | 'SETTINGS'
  | 'NEWS'
  | 'MEMORIES'
  | 'CLIENTS_EDIT_SHIPPING'
  | 'SHIPPING_BANDS'
  | 'LOCATIONS_TYPE'
  | 'CLIENTS_EDIT_USER'
  | 'GENERATE_TICKETS'
  | 'PHOTO_GALLERY'
  | 'PERMISSIONS'
  | 'PERMISSIONS_EDIT_USER'
  | 'VIDEO_GALLERY'
  | 'CHANGE_LOG'
  | 'TOP_UP_WRISTBAND'
  | 'LOCATIONS_MAP'
  | 'ORDERS_CANCEL'
  | 'SUPPORT'
  | 'CLIENTS'
  | 'UPLOAD_IMAGES'
  | 'PERMISSIONS_EDIT_USER_GROUPS'
  | 'PARTNERS_LIST'
  | 'CLIENTS_DELETE'
  | 'CLIENTS_EDIT_BILLING'
  | 'TICKETS_CATEGORY'
  | 'VENDORS'
  | 'CAMPAIGNS'
  | 'SCAN_TICKETS'
  | 'STAFF'

export interface MenuItem {
  title: string
  path: string
  children?: MenuItem[]
  festival?: boolean
  icon?: JSX.Element
  festivalName?: string
  editionId?: string
  festivalItem?: IFestivalMenuItem
  view?: boolean
  edit?: boolean
  type?: TPermissionTypes
}

export const MenuItems: MenuItem[] = [
  {
    title: 'Artists',
    path: '/artists',
    type: 'ARTISTS',
    view: false,
    edit: false,
  },
  {
    title: 'Stages',
    path: '/stages',
    type: 'STAGES',
    view: false,
    edit: false,
  },
  {
    title: 'News',
    path: '/news',
    type: 'NEWS',
    view: false,
    edit: false,
  },
  {
    title: 'Map',
    path: '/map',
    children: [
      {
        title: 'Types',
        path: '/map/types',
        type: 'LOCATIONS_TYPE',
        view: false,
        edit: false,
      },
      {
        title: 'Locations',
        path: '/map/locations',
        type: 'LOCATIONS_MAP',
        view: false,
        edit: false,
      },
    ],
    view: false,
    edit: false,
  },
  {
    title: 'Media',
    path: '/media',
    children: [
      {
        title: 'Photo',
        path: '/media/photo',
        type: 'PHOTO_GALLERY',
        view: false,
        edit: false,
      },
      {
        title: 'Video',
        path: '/media/video',
        type: 'VIDEO_GALLERY',
        view: false,
        edit: false,
      },
    ],
    view: false,
    edit: false,
  },
  {
    title: 'Assets',
    path: '/assets',
    type: 'UPLOAD_IMAGES',
    view: false,
    edit: false,
  },
  {
    title: 'Partners',
    path: '/partners',
    children: [
      {
        title: 'Categories',
        path: '/partners/categories',
        type: 'PARTNERS_CATEGORIES',
        view: false,
        edit: false,
      },
      {
        title: 'Partners',
        path: '/partners/partners',
        type: 'PARTNERS_LIST',
        view: false,
        edit: false,
      },
    ],
    view: false,
    edit: false,
  },
  {
    title: 'Info Pages',
    path: '/info-pages',
    type: 'INFO',
    view: false,
    edit: false,
  },
  {
    title: 'Memories',
    path: '/memories',
    type: 'MEMORIES',
    view: false,
    edit: false,
  },
  {
    title: 'Notifications',
    path: '/notifications',
    type: 'NOTIFICATIONS',
    view: false,
    edit: false,
  },
  {
    title: 'Tickets',
    path: '/tickets',
    type: 'TICKETS',
    children: [
      {
        title: 'Categories',
        path: '/tickets/categories',
        type: 'TICKETS_CATEGORY',
        view: false,
        edit: false,
      },
      {
        title: 'Tickets',
        path: '/tickets/tickets',
        type: 'TICKETS',
        view: false,
        edit: false,
      },
      {
        title: 'Add-ons',
        path: '/tickets/add-ons',
        type: 'TICKETS_ADD_ONS',
        view: false,
        edit: false,
      },
    ],
    view: false,
    edit: false,
  },
  {
    title: 'Orders',
    path: '/orders',
    type: 'ORDERS',
    view: false,
    edit: false,
  },
  {
    title: 'Clients',
    path: '/clients',
    type: 'CLIENTS',
    view: false,
    edit: false,
  },
  {
    title: 'Rewards',
    path: '/rewards',
    type: 'VOUCHERS',
    children: [
      {
        title: 'Vouchers',
        path: '/rewards/vouchers',
        type: 'VOUCHERS',
        view: false,
        edit: false,
      },
      {
        title: 'Voucher Downloads',
        path: '/rewards/vouchers/downloads',
        type: 'VOUCHERS',
        view: false,
        edit: false,
      },
      {
        title: 'Invites',
        path: '/rewards/invites',
        type: 'INVITES',
        view: false,
        edit: false,
      },
      {
        title: 'Invite Downloads',
        path: '/rewards/invites/downloads',
        type: 'INVITES',
        view: false,
        edit: false,
      },
      {
        title: 'Redeem Vouchers',
        path: '/rewards/redeem-vouchers',
        type: 'VOUCHERS',
        view: false,
        edit: false,
      },
    ],
    view: false,
    edit: false,
  },
  {
    title: 'Generate Tickets',
    path: '/generate-tickets',
    type: 'GENERATE_TICKETS',
    view: false,
    edit: false,
  },
  {
    title: 'Scan Tickets',
    path: '/scan-tickets',
    type: 'SCAN_TICKETS',
    view: false,
    edit: false,
  },
  {
    title: 'Shipping Bands',
    path: '/shipping-bands',
    type: 'SHIPPING_BANDS',
    view: false,
    edit: false,
  },
  {
    title: 'Top Up Wristband',
    path: '/top-up-wristband',
    type: 'TOP_UP_WRISTBAND',
    view: false,
    edit: false,
  },
  {
    title: 'Referrals',
    path: '/referrals',
    type: 'REFERRALS',
    view: false,
    edit: false,
  },
  {
    title: 'Vendors',
    path: '/vendors',
    type: 'VENDORS',
    view: false,
    edit: false,
  },
  {
    title: 'Campaigns',
    path: '/campaigns',
    type: 'CAMPAIGNS',
    view: false,
    edit: false,
  },
  {
    title: 'Staff',
    path: '/staff',
    type: 'STAFF',
    view: false,
    edit: false,
  },
  {
    title: 'Settings',
    path: '/settings',
    type: 'SETTINGS',
    children: [
      {
        title: 'General',
        path: '/settings/general',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'Menu',
        path: '/settings/menu',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'SEO',
        path: '/settings/seo',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'Financial',
        path: '/settings/financial',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'Default Images',
        path: '/settings/default-images',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'Theme',
        path: '/settings/theme',
        type: 'SETTINGS',
        children: [
          {
            title: 'General',
            path: '/settings/theme/general',
            type: 'SETTINGS',
            view: false,
            edit: false,
          },
          {
            title: 'Images',
            path: '/settings/theme/images',
            type: 'SETTINGS',
            view: false,
            edit: false,
          },
        ],
        view: false,
        edit: false,
      },
      {
        title: 'Notifications',
        path: '/settings/notifications',
        type: 'SETTINGS',
        children: [
          {
            title: 'Links',
            path: '/settings/notifications/links',
            type: 'SETTINGS',
            view: false,
            edit: false,
          },
        ],
        view: false,
        edit: false,
      },
      {
        title: 'Custom Code',
        path: '/settings/custom-code',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'Email Templates',
        path: '/settings/email-templates',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'Custom Fields',
        path: '/settings/notifications/custom-fields',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'Permissions',
        path: '/settings/permissions',
        type: 'SETTINGS',
        children: [
          {
            title: 'User Groups',
            path: '/settings/permissions/user-groups',
            type: 'SETTINGS',
            view: false,
            edit: false,
          },
          {
            title: 'Users',
            path: '/settings/permissions/users',
            type: 'SETTINGS',
            view: false,
            edit: false,
          },
        ],
        view: false,
        edit: false,
      },
      {
        title: 'Languages',
        path: '/settings/languages',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
      {
        title: 'Activity Log',
        path: '/settings/activity-log',
        type: 'SETTINGS',
        view: false,
        edit: false,
      },
    ],
    view: false,
    edit: false,
  },
  {
    title: 'Support',
    path: '/support',
    type: 'SUPPORT',
    view: false,
    edit: false,
  },
]

export const festivals = [
  {
    name: 'Untold',
    editions: [
      { label: '2023', value: 'ef6fd65b-81a8-45e9-bbe4-33d9cfe96dad' },
    ],
    festivalName: 'untold',
  },
  // {
  //   name: 'Untold Dubai',
  // },
  {
    name: 'Neversea',
    editions: [
      { label: '2023', value: 'e664f241-7c12-4dba-8732-17b7e537bb26' },
    ],
    festivalName: 'neversea',
  },
  // {
  //   name: 'BeMassif',
  // },
]

export const dashboardMenuItems: MenuItem[] = [
  {
    title: 'Artists',
    path: '/artists',
    type: 'ARTISTS',
    view: false,
    edit: false,
  },
  {
    title: 'Stages',
    path: '/stages',
    type: 'STAGES',
    view: false,
    edit: false,
  },
  {
    title: 'News',
    path: '/news',
    type: 'NEWS',
    view: false,
    edit: false,
  },
  {
    title: 'Media Gallery',
    path: '/media/photo',
    view: false,
    edit: false,
  },
  {
    title: 'Orders',
    path: '/orders',
    type: 'ORDERS',
    view: false,
    edit: false,
  },
  {
    title: 'Clients',
    path: '/clients',
    type: 'CLIENTS',
    view: false,
    edit: false,
  },
  {
    title: 'Support',
    path: '/support',
    type: 'SUPPORT',
    view: false,
    edit: false,
  },
  {
    title: 'Custom Currency',
    path: '/custom-currency',
    view: false,
    edit: false,
  },
]
